import { ReactComponent as MHIcon } from "../../static/svg/brand/CaringAfrica_logo.svg";

export default function MHLogo({ style }: { style?: object }) {
  return (
    <MHIcon
      width="5rem"
      height="auto"
      style={{
        margin: "0 auto",
        ...style,
      }}
    />
  );
}
